export default {
  IDLE: 'idle',
  INTERACTION: 'interaction',
  WATCH_CREDITS: 'watch-credits',
};
